import { IconTargetArrow } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { NSCard } from 'bricks';
import classNames from 'classnames';
import { Deal } from 'views/Deals/types';
import { BOEScenario } from '../types';
import { formatBOEValues, generateScenarioReturns } from '../helper';
import './ScenarioReturns.scss';

export interface IScenarioReturnsProps {
    boeScenario: BOEScenario;
    deal?: Deal;
}

const ScenarioReturns = ({ boeScenario, deal }: IScenarioReturnsProps) => {
    const scenarioReturns = generateScenarioReturns(boeScenario, deal);
    return (
        <div>
            <span className="text-muted">SCENARIO RETURNS</span>
            <div className="d-flex flex-row py-1" style={{ gap: 16 }}>
                {scenarioReturns.map(scenario => (
                    <NSCard
                        key={scenario.title[0]}
                        className={classNames('NSCard--level-4 p-2 flex-grow-1 ScenarioReturns__card', {
                            'ScenarioReturns__card--success': scenario.displayMode === 'success',
                            'ScenarioReturns__card--error': scenario.displayMode === 'danger',
                        })}
                    >
                        <div className="d-flex flex-row justify-content-between">
                            <span className="text-muted">{scenario.title[0]}</span>
                            <div className="d-flex flex-row align-items-center">
                                <NSIcon
                                    icon={IconTargetArrow}
                                    className={classNames('pr-1', {
                                        'text-danger': scenario.displayMode === 'danger',
                                        'text-success': scenario.displayMode === 'success',
                                    })}
                                />
                                <span>{formatBOEValues(scenario.target !== null ? Number(scenario.target) : null, scenario.formatter[0])}</span>
                            </div>
                        </div>
                        <h3 className="text-white bold mb-0 mt-1">{formatBOEValues(Number(scenario.value[0]), scenario.formatter[0])}</h3>
                    </NSCard>
                ))}
            </div>
        </div>
    );
};

export default ScenarioReturns;
